// src/modules/app-views/serviceOrders/pages/Init/components/tableColumns/numberColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function numberColumn(buildColumnProps, options = {}) {
  const {
    key = 'documentNumber',
    title = 'document_number',
    dataIndex = 'documentNumber',
    width = 140,
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const num = r?.documentNumber || '—';
      const isBudget = r?.type === 'budget';
      return (
        <div className="d-flex align-items-center" style={{ gap: 6 }}>
          <Tag color={isBudget ? 'blue' : 'green'} style={{ margin: 0, fontSize: 10 }}>
            {isBudget ? translateX('budget') : 'OS'}
          </Tag>
          <span className="font-weight-semibold">{num}</span>
        </div>
      );
    },
  };
}

export default numberColumn;
